import React, { useState } from 'react';
import FsLightbox from 'fslightbox-react';
import { FiPlay } from "react-icons/fi";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';




const PopupData = [
    {
        id: "01",
        image: './images/about/contact-image.jpg', 
        popupLink: [
            'https://www.youtube.com/watch?v=689FgpbHEa4',
        ],
    }
]

// Helper function to extract the Video ID from the 'watch' URL
const getYouTubeVideoId = (url) => {
    try {
        const urlParams = new URLSearchParams(new URL(url).search);
        return urlParams.get('v');
    } catch (e) {
        return null;
    }
};


const AboutFour = ({image}) => {
    const [toggler, setToggler] = useState(false);

    const item = PopupData[0];
    const imagePath = item.image;
    
    const videoId = getYouTubeVideoId(item.popupLink[0]);
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

    // Custom Iframe Source with referrerPolicy and responsive sizing
    const customIframe = (
        <div 
          style={{
            position: 'relative',
            width: '90vw', 
            paddingTop: '50.625vw',
            margin: '0 auto',
            display: 'block', 
            marginTop: '30px',
          }}
        >
            <iframe
                referrerPolicy="strict-origin-when-cross-origin" 
                src={embedUrl}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                }}
            />
        </div>
    );


    return (
        <div className="about-area about-style-4 rn-section-gap">
            <div className="container">
                <div className="row row--40 align-items-center">
                    <div className="col-lg-6">
                        <div className="video-btn" key={item.id}>
                            <div className="video-popup icon-center">
                                <div className="thumbnail">
                                    <img 
                                        className="radius-small" 
                                        src='./images/about/contact-image.jpg' 
                                        alt="Video Thumbnail" 
                                    />
                                </div>
                                <div className="video-icon">
                                    <button 
                                        className="btn-default rounded-player" 
                                        onClick={() => setToggler(!toggler)}
                                    >
                                        <span><FiPlay /></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Video Section */}
                    
                    <div className="col-lg-6 mt_md--40 mt_sm--40">
                        <div className="content">
                            <div className="inner">
                                <h3 className="title">About Passionate World University(PWU)</h3>
                                <div>
                                    <p>Passionate World University (PWU) is a purpose-driven education and consulting platform built to unlock human potential and create income opportunities through world-class training, coaching, and community support. Founded by Jahid Hasan, PWU is designed for aspiring entrepreneurs, business owners, CEOs, executives, professionals, and students—anyone committed to transforming their life, business, and income.
                                    </p>
                                </div>
                                <div className="about-btn mt--30">
                                    <Link className="btn-default" to="/about-us">About Our PWU</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FsLightbox toggler={toggler} sources={[customIframe]} />
        </div>
    )
}

export default AboutFour;